import store from "@/store";
import { Message } from "element-ui";

const bool = process.env.NODE_ENV === "production";
const uploadUrl = bool
  ? `https://${window.location.host}/api/cloud/file/uploadFile`
  : "/api/cloud/file/uploadFile";

/**
 * Configure wangeditor for help answers: image upload + paste.
 */
export function configureHelpWangEditor(editor) {
  if (!editor || !editor.config) return;
  const token = store.state?.loginAccountInfo?.token || "";
  editor.config.placeholder = "支持文字、上传图片与粘贴图片";
  editor.config.showLinkImg = false;
  editor.config.uploadImgMaxLength = 5;
  editor.config.customUploadImg = (files, insertImgFn) => {
    const list = Array.from(files || []);
    list.forEach((file) => {
      const form = new FormData();
      form.append("file", file);
      form.append("file_type", "picture");
      fetch(uploadUrl, {
        method: "POST",
        headers: token ? { token } : {},
        body: form,
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status !== "success") {
            throw new Error(res.msg || "上传失败");
          }
          const url =
            res.data?.file_down_path ||
            res.data?.fileDownPath ||
            res.data?.file_src ||
            res.data?.fileSrc ||
            res.data?.url;
          if (!url || typeof url !== "string") {
            throw new Error("未返回图片地址");
          }
          insertImgFn(url);
        })
        .catch((e) => {
          console.error(e);
          Message.error(e.message || "图片上传失败");
        });
    });
  };
}
